import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GameButtonStyled, {
  GameButtonWrap,
  ButtonSVG,
} from './GameButton.styled';
import { onTriggerGame } from '../../../state-actions/onTriggerGame';

const mapDispatchToProps = dispatch => ({
  onTriggerGame: level => dispatch(onTriggerGame(level)),
});

const lockedOrPlay = locked => {
  if (locked) {
    return (
      <ButtonSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
        <path d="M12 7V5a4 4 0 0 0-8 0v2H3v3a5 5 0 0 0 10 0V7h-1zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.5-4h-5V5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5v2z" />
      </ButtonSVG>
    );
  }
  return 'Play!';
};

export const GameButton = ({ level, locked, onTriggerGame }) => (
  <GameButtonWrap>
    <GameButtonStyled
      {...locked && { disabled: true }}
      onClick={() => onTriggerGame(level)}
      title={locked ? 'Locked' : 'Play!'}
    >
      {lockedOrPlay(locked)}
    </GameButtonStyled>
  </GameButtonWrap>
);

export default connect(
  null,
  mapDispatchToProps
)(GameButton);

GameButton.propTypes = {
  level: PropTypes.number.isRequired,
  locked: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/GameButton/GameButton.js